// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607281604/js/" + chunkId + "." + {"44":"5403c595","225":"6b21171f","481":"a3b05bac","486":"683eaddb","770":"40578e8d"}[chunkId] + ".0.4025555495390487.chunk.js";
};